/**
 * Profile photos are stored at a stable S3 path per user, so the URL string often
 * does not change between uploads. Append a cache-bust query param so browsers
 * fetch the latest image after /me or session refresh.
 */
export const withprofilePhotoCache = (url, cacheBust) => {
  if (!url) {
    return null;
  }
  const [baseUrl, hash = ""] = url.split("#");
  const separator = baseUrl.includes("?") ? "&" : "?";
  const cacheBusted = `${baseUrl}${separator}cb=${cacheBust}`;
  return hash ? `${cacheBusted}#${hash}` : cacheBusted;
};

export const getProfilePhotoDisplaySrc = (
  profilePhotoUrl,
  cacheBust,
  fallback = null,
) => {
  if (!profilePhotoUrl) {
    return fallback;
  }
  if (profilePhotoUrl.startsWith("data:")) {
    return profilePhotoUrl;
  }
  return withprofilePhotoCache(profilePhotoUrl, cacheBust);
};
